import _extends from "@babel/runtime-corejs3/helpers/extends";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { safeGetId, useDownshiftContext } from '../../../../core';
import DefaultOption from '../../../shared/components/defaults/option';
import DefaultFixture from '../../../shared/components/defaults/fixture';
import Menu from '../../../shared/components/menu';
import MenuContent from '../../../shared/components/menu-content';

function SingleTypeSelectMenu(_ref) {
  var Option = _ref.Option,
      Fixture = _ref.Fixture,
      Helper = _ref.Helper,
      Loading = _ref.Loading,
      NoResultsFound = _ref.NoResultsFound,
      _ref$fixtures = _ref.fixtures,
      fixtures = _ref$fixtures === void 0 ? [] : _ref$fixtures,
      _ref$hasFixture = _ref.hasFixture,
      hasFixture = _ref$hasFixture === void 0 ? true : _ref$hasFixture,
      width = _ref.width;

  var _useDownshiftContext = useDownshiftContext(),
      items = _useDownshiftContext.items,
      isOpen = _useDownshiftContext.isOpen,
      highlightedIndex = _useDownshiftContext.highlightedIndex,
      selectedItem = _useDownshiftContext.selectedItem,
      selectedItems = _useDownshiftContext.selectedItems,
      getMenuProps = _useDownshiftContext.getMenuProps,
      getItemProps = _useDownshiftContext.getItemProps,
      getFixtureProps = _useDownshiftContext.getFixtureProps;

  var fixtureIndex = items.length;
  return /*#__PURE__*/React.createElement(Menu, _extends({}, getMenuProps({
    refKey: 'innerRef'
  }), {
    width: width
  }), isOpen && /*#__PURE__*/React.createElement(MenuContent, {
    Helper: Helper,
    Loading: Loading,
    NoResultsFound: NoResultsFound
  }, _mapInstanceProperty(items).call(items, function (item, index) {
    var _item$Option;

    var RenderOption = (_item$Option = item === null || item === void 0 ? void 0 : item.Option) !== null && _item$Option !== void 0 ? _item$Option : Option;
    return /*#__PURE__*/React.createElement(DefaultOption, _extends({
      key: safeGetId(item)
    }, getItemProps({
      item: item,
      index: index,
      isHighlighted: highlightedIndex === index,
      isSelected: selectedItems ? _findInstanceProperty(selectedItems).call(selectedItems, function (i) {
        return safeGetId(i) === safeGetId(item);
      }) : safeGetId(selectedItem) === safeGetId(item),
      Option: RenderOption
    }), {
      item: item,
      index: index
    }));
  }), hasFixture ? _mapInstanceProperty(fixtures).call(fixtures, function (fixture, index) {
    var RenderFixture = (fixture === null || fixture === void 0 ? void 0 : fixture.Fixture) || Fixture;
    return /*#__PURE__*/React.createElement(DefaultFixture, _extends({
      key: index
    }, getFixtureProps({
      items: items,
      fixture: fixture,
      index: fixtureIndex + index,
      isHighlighted: highlightedIndex === fixtureIndex + index,
      Fixture: RenderFixture
    }), {
      index: fixtureIndex + index
    }));
  }) : null));
}

export default SingleTypeSelectMenu;